import { Component, OnInit, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss']
})
export class ContentComponent implements OnInit {
  status: boolean = false;
  courseDetails: any;
  courseDesc: any;
  searchedCourse: string = "";
  searchResult: Array<any> = [];
  hide_result: any = false;
  courses = [
    {
      id: 0,
      title: "CBSE GRADE 9 Mathematics/science",
      shortDesc: "Course for CBSE Grade 9 Mathematics/science students",
      desc: [
        {
          title: "Vacation cum regular batch"
        },
        {
          title: "Regular batch"
        }
      ]
    },
    {
      id: 1,
      title: "CBSE GRADE 10 Mathematics/science",
      shortDesc: "Course for CBSE Grade 10 Mathematics/science students",
      desc: [
        {
          title: "Vacation Batch"
        },
        {
          title: "Vacation cum regular batch"
        },
        {
          title: "Regular batch"
        }
      ]
    },
    {
      id: 2,
      title: "CBSE GRADE 11 and 12 Physics/chemistry/mathematics/Biology",
      shortDesc: "Course for CBSE Grade 11 and 12 Physics/chemistry/mathematics/Biology students",
      desc: [
        {
          title: "Vacation Batch"
        },
        {
          title: "Vacation cum regular batch"
        },
        {
          title: "Regular batch"
        }
      ]
    },
    {
      id: 3,
      title: "I PUC Physics/chemistry/mathematics/Biology",
      shortDesc: "Course for I PUC Physics/chemistry/mathematics/Biology",
      desc: [
        {
          title: "Regular batch"
        }
      ]
    },
    {
      id: 4,
      title: "II PUC Physics/chemistry/mathematics/Biology",
      shortDesc: "Course for II PUC Physics/chemistry/mathematics/Biology",
      desc: [
        {
          title: "Vacation Batch"
        },
        {
          title: "Vacation cum regular batch"
        },
        {
          title: "Regular batch"
        }
      ]
    },
    {
      id: 5,
      title: "NEET REGULAR BATCH",
      shortDesc: "Course for NEET aspirants",
      desc: [
        {
          title: "Regular batch"
        }
      ]
    },
    {
      id: 6,
      title: "NEET CRASH COURSE",
      shortDesc: "NEET crash course for the aspirants",
      desc: [
        {
          title: "Crash course"
        }
      ]
    },
    {
      id: 7,
      title: "CET REGULAR BATCH",
      shortDesc: "Course for CET aspirants",
      desc: [
        {
          title: "Regular batch"
        }
      ]
    },
    {
      id: 8,
      title: "CET CRASH COURSE",
      shortDesc: "CET Crash Course for the aspirants",
      desc: [
        {
          title: "Crash course"
        }
      ]
    },
    {
      id: 9,
      title: "FOUNDATION COURSE FOR Grade 7 and 8",
      shortDesc: "Foundation Course FOR Grade 7 and 8 students",
      desc: [
        {
          title: "Vacation batch"
        }
      ]
    },
    {
      id: 10,
      title: "Rapid Mathematics course for all the classes",
      shortDesc: "Rapid Mathematics course for all the classes",
      desc: [
        {
          title: "Vacation batch"
        }
      ]
    }
  ];
  constructor(private renderer: Renderer2) { }

  ngOnInit() {
  }

  clickEvent(courseDetails, courseDesc) {
    this.status = !this.status;
    this.courseDetails = courseDetails;
    this.courseDesc = courseDesc
    this.renderer.addClass(document.body, 'modal-open');
  }

  close() {
    this.status = !this.status;
    this.renderer.removeClass(document.body, 'modal-open');
  }

  search = (value) => {
    let resultArray = [];
    for (var i = 0; i < this.courses.length; i++) {
      if (this.courses[i].title.match(new RegExp(value, 'i'))) {
        resultArray.push(this.courses[i])
      }
    }
    return resultArray;
  };

  searchCourse = (value) => {
    this.searchResult = this.search(value);
    document.body.addEventListener('click', this.hideSearchResults);
  }

  focusCourse = (course, i) => {
    let element = document.getElementById(`courses_${i}`);
    window.scrollTo(element.offsetLeft, element.offsetTop);
    this.searchedCourse= "";
  }

  showSearchResults = (event) => {
    this.hide_result = false;
    let element = document.getElementById('searchField');
    element.removeEventListener('click', this.showSearchResults);
    setTimeout(() => {
      document.body.addEventListener('click', this.hideSearchResults);
    }, 100);
  };

  hideSearchResults = (event) => {
    if(event.target && event.target.id === "searchField") {
      return;
    }
    this.hide_result = true;
    document.body.removeEventListener('click', this.hideSearchResults);
    let element = document.getElementById('searchField');
    element.addEventListener('click', this.showSearchResults);
  };
}
